let hasRegistered = false

export const registerServiceWorker = () => {
  if (hasRegistered || typeof window === 'undefined') return
  hasRegistered = true

  if ('serviceWorker' in navigator) {
    const register = () => {
      navigator.serviceWorker
        .register('/analytics-service-worker.js')
        .then((registration) => {
          console.log('Analytics ServiceWorker registered:', registration)
        })
        .catch((error) => {
          console.error('Analytics ServiceWorker registration failed:', error)
        })
    }

    if (document.readyState === 'complete') {
      register()
    } else {
      window.addEventListener('load', () => register(), { once: true })
    }
  } else {
    console.log('Analytics ServiceWorker not supported')
  }
}
